import { map } from 'rxjs';
import { ADMIN_API } from '../AdminAPI';
import { convertUnixToDate } from '@golden/gdk-base';
import { getUnixTime } from 'date-fns';
export function createSmsService(api) {
    return {
        getSmsProviders() {
            return api.fetch(ADMIN_API.GET_SMS_PROVIDER_LIST);
        },
        updateSmsProvider(data) {
            return api.fetch(ADMIN_API.PUT_SMS_PROVIDER, { data });
        },
        getSmsHistory(payload) {
            const data = {
                ...payload
            };
            if (data.send_start_at)
                data.send_start_at = getUnixTime(data.send_start_at);
            if (data.send_end_at)
                data.send_end_at = getUnixTime(data.send_end_at);
            if (data.verify_start_at)
                data.verify_start_at = getUnixTime(data.verify_start_at);
            if (data.verify_end_at)
                data.verify_end_at = getUnixTime(data.verify_end_at);
            return api.fetch(ADMIN_API.GET_SMS_HISTORY, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'verified_at'))
            })));
        },
        resendSms(id, provider) {
            return api.fetch(ADMIN_API.POST_RESEND_SMS, { data: { provider }, config: { urlParams: { id } } });
        }
    };
}
//# sourceMappingURL=SmsService.js.map